import { getTagsByContext } from '../../api/tagsApi'
import NavBar from '../../components/nav-bar/nav-bar'
import translate from '../../i18n'
import { setAllCategoriesAction } from '../../store/category/action'
import { TaggingContextEnums } from '../tags-container/constant'
import { Card, Space } from 'antd'
import { useEffect } from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { Outlet } from 'react-router-dom'
import { useLocation } from 'react-router-dom'
import { compose } from 'redux'

const StudioLeaderboardCategoriesContainer = (props: ConnectedProps<typeof withConnect>) => {
  const location = useLocation()
  const { setAllCategoriesAction } = props

  useEffect(() => {
    getTagsByContext(TaggingContextEnums.PRIMARY_CATEGORY).then(primaryCategoryTags => {
      getTagsByContext(TaggingContextEnums.ACTIVITIES).then(activityTags => {
        activityTags[TaggingContextEnums.PRIMARY_CATEGORY] =
          primaryCategoryTags[TaggingContextEnums.PRIMARY_CATEGORY]
        setAllCategoriesAction(activityTags)
      })
    })
  }, [])

  const getNavBarTitle = () => {
    const pathName = location.pathname
    if (pathName.match(/^\/studio-leaderboard-categories\/[0-9]+\/edit$/)) {
      return translate('navBar.editStudioLeaderboardCategories')
    }

    if (pathName.match(/^\/studio-leaderboard-categories\/new/)) {
      return translate('navBar.newStudioLeaderboardCategories')
    }

    if (pathName.match(/^\/studio-leaderboard-categories\/[0-9]+$/)) {
      return translate('navBar.viewStudioLeaderboardCategories')
    }

    return translate('navBar.studioLeaderboardCategoriesTitle')
  }

  return (
    <Space className="dashboard-wrapper" orientation="vertical">
      <NavBar title={getNavBarTitle()}></NavBar>
      <Card>
        <Outlet />
      </Card>
    </Space>
  )
}

const mapDispatchToProps = {
  setAllCategoriesAction,
}

const withConnect = connect(null, mapDispatchToProps)

export default compose(withConnect)(StudioLeaderboardCategoriesContainer)
